import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Attach(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M15.397 5.585a4.12 4.12 0 00-5.316 1.083l-5.286 6.938a1 1 0 01-1.59-1.212L8.49 5.456a6.12 6.12 0 019.876 7.224l-5.186 7.39a4.462 4.462 0 11-7.246-5.207l4.97-6.756a2.756 2.756 0 114.424 3.287L11.8 16.1a1 1 0 01-1.6-1.2l3.53-4.706a.756.756 0 10-1.215-.902l-4.97 6.756a2.462 2.462 0 104 2.873l5.185-7.39a4.12 4.12 0 00-1.333-5.946z",
    clipRule: "evenodd"
  }));
}

export default Attach;